import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BookingModal from "./BookingModal";
import Map from "./Map";

const Service = () => {
  const [services, setServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    fetch("https://feniceshieldchemical.bwsoft.in/api/api/services/")
      .then((response) => response.json())
      .then((data) => {
        setServices(data);
      })
      .catch((error) => {
        console.error("Error fetching the services:", error);
      });
  }, []);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  return (
    <div>
      <div className="banner">
        <img src="assets/img/service.jpg" alt="Service Banner" />
      </div>

      <section id="services" className="services section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Services</h2>
        </div>

        <div className="container services">
          <div className="row gy-4">
            {services.length > 0 ? (
              services.map((service, index) => (
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-delay={100 * (index + 1)}
                  key={service.id}
                >
                  <div className="service-item d-flex">
                    <div className="icon flex-shrink-0">
                      <i className="bi bi-briefcase"></i>
                    </div>
                    <div>
                      <h4 className="title">
                        <Link
                          onClick={() => handleServiceClick(service)}
                          className="stretched-link"
                        >
                          {service.name}
                        </Link>
                      </h4>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No services available at the moment.</p>
            )}
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        service={selectedService}
        userId={userId}
      />
    </div>
  );
};

export default Service;
